export const moneyFormatter = (
	val: string | number | null | undefined,
	currencySign: string,
	emptyVal = "",
	decimals?: number,
) => {
	if (val === null || val === undefined || val === "") return emptyVal;

	const numVal = Number(val);
	if (Number.isNaN(numVal)) return emptyVal;

	const formattedVal =
		decimals !== undefined ? numVal.toFixed(decimals) : numVal.toString();

	return `${Number(formattedVal).toLocaleString("cs-CZ")}\u00A0${currencySign}`;
};
